/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { breedControllerCreate } from '../fn/breed/breed-controller-create';
import { BreedControllerCreate$Params } from '../fn/breed/breed-controller-create';
import { breedControllerDelete } from '../fn/breed/breed-controller-delete';
import { BreedControllerDelete$Params } from '../fn/breed/breed-controller-delete';
import { breedControllerFindAllActive } from '../fn/breed/breed-controller-find-all-active';
import { BreedControllerFindAllActive$Params } from '../fn/breed/breed-controller-find-all-active';
import { breedControllerFindById } from '../fn/breed/breed-controller-find-by-id';
import { BreedControllerFindById$Params } from '../fn/breed/breed-controller-find-by-id';
import { breedControllerSearch } from '../fn/breed/breed-controller-search';
import { BreedControllerSearch$Params } from '../fn/breed/breed-controller-search';
import { breedControllerToggleActive } from '../fn/breed/breed-controller-toggle-active';
import { BreedControllerToggleActive$Params } from '../fn/breed/breed-controller-toggle-active';
import { breedControllerUpdate } from '../fn/breed/breed-controller-update';
import { BreedControllerUpdate$Params } from '../fn/breed/breed-controller-update';
import { BreedDto } from '../models/breed-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class BreedService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `breedControllerSearch()` */
  static readonly BreedControllerSearchPath = '/api/breed';

  /**
   * 품종 목록 조회.
   *
   * 품종 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerSearch$Response(params: BreedControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<BreedDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = breedControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 목록 조회.
   *
   * 품종 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerSearch(params: BreedControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<BreedDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.breedControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<BreedDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<BreedDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `breedControllerCreate()` */
  static readonly BreedControllerCreatePath = '/api/breed';

  /**
   * 품종 등록.
   *
   * 새로운 품종을 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  breedControllerCreate$Response(params: BreedControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
    const obs = breedControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 등록.
   *
   * 새로운 품종을 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  breedControllerCreate(params: BreedControllerCreate$Params, context?: HttpContext): Observable<BreedDto> {
    const resp = this.breedControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BreedDto>): BreedDto => r.body)
    );
  }

  /** Path part for operation `breedControllerFindAllActive()` */
  static readonly BreedControllerFindAllActivePath = '/api/breed/active';

  /**
   * 활성화된 품종 목록 조회.
   *
   * 활성화된 품종 목록을 조회합니다. (드롭다운용)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerFindAllActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerFindAllActive$Response(params?: BreedControllerFindAllActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BreedDto>>> {
    const obs = breedControllerFindAllActive(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 활성화된 품종 목록 조회.
   *
   * 활성화된 품종 목록을 조회합니다. (드롭다운용)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerFindAllActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerFindAllActive(params?: BreedControllerFindAllActive$Params, context?: HttpContext): Observable<Array<BreedDto>> {
    const resp = this.breedControllerFindAllActive$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<BreedDto>>): Array<BreedDto> => r.body)
    );
  }

  /** Path part for operation `breedControllerFindById()` */
  static readonly BreedControllerFindByIdPath = '/api/breed/{id}';

  /**
   * 품종 상세 조회.
   *
   * 품종을 ID로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerFindById$Response(params: BreedControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
    const obs = breedControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 상세 조회.
   *
   * 품종을 ID로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerFindById(params: BreedControllerFindById$Params, context?: HttpContext): Observable<BreedDto> {
    const resp = this.breedControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BreedDto>): BreedDto => r.body)
    );
  }

  /** Path part for operation `breedControllerDelete()` */
  static readonly BreedControllerDeletePath = '/api/breed/{id}';

  /**
   * 품종 삭제.
   *
   * 품종을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerDelete$Response(params: BreedControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
    const obs = breedControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 삭제.
   *
   * 품종을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerDelete(params: BreedControllerDelete$Params, context?: HttpContext): Observable<BreedDto> {
    const resp = this.breedControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BreedDto>): BreedDto => r.body)
    );
  }

  /** Path part for operation `breedControllerUpdate()` */
  static readonly BreedControllerUpdatePath = '/api/breed/{id}';

  /**
   * 품종 수정.
   *
   * 품종 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerUpdate$Response(params: BreedControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
    const obs = breedControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 수정.
   *
   * 품종 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerUpdate(params: BreedControllerUpdate$Params, context?: HttpContext): Observable<BreedDto> {
    const resp = this.breedControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BreedDto>): BreedDto => r.body)
    );
  }

  /** Path part for operation `breedControllerToggleActive()` */
  static readonly BreedControllerToggleActivePath = '/api/breed/{id}/toggle-active';

  /**
   * 품종 활성화 토글.
   *
   * 품종의 활성화 상태를 토글합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `breedControllerToggleActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerToggleActive$Response(params: BreedControllerToggleActive$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
    const obs = breedControllerToggleActive(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 품종 활성화 토글.
   *
   * 품종의 활성화 상태를 토글합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `breedControllerToggleActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  breedControllerToggleActive(params: BreedControllerToggleActive$Params, context?: HttpContext): Observable<BreedDto> {
    const resp = this.breedControllerToggleActive$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BreedDto>): BreedDto => r.body)
    );
  }

}
